import tomasImage from "../assets/img/tomas.jpg";
import josueImage from "../assets/img/josue.jpg";
import lucasImage from "../assets/img/lucas.png";
import ayrtonImage from "../assets/img/ayrton.jpg";
import franImage from "../assets/img/fran.png";
import milagrosImage from "../assets/img/milagros.jpg";

export interface ITestimonial {
  name: string;
  comment: string;
  comment2: string;
  comment3: string;
  role: string;
  profilePicture: string;
}

export const englishTestimonials: Array<ITestimonial> = [
  {
    name: "Josue Goyret",
    comment:
      "Sebas is a proactive and committed professional, capable of understanding the needs of the frontend and generating efficient services from backend with clean code that is easy to maintain.",
    comment2:
      "His focus goes beyond responsibilities, seeking opportunities for improvement and adding value",
    comment3:
      "In addition to his technical skills, he stands out for his communication skills, which makes him a valuable asset to any project or development team.",
    role: "Industrial Engineer",
    profilePicture: josueImage,
  },
  {
    name: "Milagros Molina",
    comment:
      "Sebastian has been a remarkable team member throughout our time working together on the projects.",
    comment2:
      "He consistently demonstrates a willingness to help others, whether it's providing technical support, sharing his knowledge, or taking on additional tasks when needed.",
    comment3:
      "Sebastian consistently meets deadlines and achieves set goals, demonstrating his professionalism and dedication to his work.",
    role: "Project Manager",
    profilePicture: milagrosImage,
  },
  {
    name: "Ayrton Juarez",
    comment:
      "I had the opportunity to follow Sebastián's professional growth as a software developer.",
    comment2:
      "I can affirm that he is an excellent professional, with a broad command of the latest technologies and a great willingness to collaborate and continue learning and perfecting his skills",
    comment3:
      "Without a doubt, a pleasure to work with him and I would definitely do it again for the value he brings to the development team.",
    role: "Software Developer",
    profilePicture: ayrtonImage,
  },
  {
    name: "Tomas Goyret",
    comment:
      "Sebas is amazing! We work together developing an app for a foundation that has a huge impact.",
    comment2:
      "His incorporation into the dev team was key in giving development a boost. I have to highlight their commitment, willingness to solve problems at any time and their technical quality.",
    comment3:
      "It was a real pleasure to work with him and I hope we continue to fully with this.",
    role: "Software Developer",
    profilePicture: tomasImage,
  },
  {
    name: "Francisco Schlatter",
    comment:
      "Working with Sebastian was an amazing experience. His technical knowledge and development skills are outstanding",
    comment2:
      "He consistently goes above and beyond to deliver exceptional results, consistently exceeding expectations.",
    comment3:
      "Sebastian's ability to efficiently solve complex problems, coupled with his positive attitude, makes him a highly reliable collaborator.",
    role: "Full Stack Developer",
    profilePicture: franImage,
  },
  {
    name: "Lucas Pedreira",
    comment:
      "I had the oportunity of working closely with Sebastian, and I can say that it was a very positive experience. ",
    comment2:
      "He consistently demonstrated his willingness to assist others, provide valuable advice, and be open to receiving feedback as well. His passion for his work shines through, and he consistently dedicates himself wholeheartedly to every task.",
    comment3: "He is a valuable asset to any team or project.",
    role: "Freelance Developer",
    profilePicture: lucasImage,
  },
];
export const spanishTestimonials: Array<ITestimonial> = [
  {
    name: "Josue Goyret",
    comment:
      "Sebas es un profesional proactivo y comprometido, capaz de entender las necesidades del frontend y generar servicios eficientes desde el backend con código limpio y de fácil mantenimiento.",
    comment2:
      "Su enfoque va más allá de las responsabilidades, buscando oportunidades de mejora y agregando valor.",
    comment3:
      "Además de sus habilidades técnicas, destaca por sus habilidades de comunicación, lo que lo convierte en un activo valioso para cualquier proyecto o equipo de desarrollo.",
    role: "Ingeniero Industrial",
    profilePicture: josueImage,
  },
  {
    name: "Milagros Molina",
    comment:
      "Sebastián ha sido un miembro extraordinario del equipo durante todo el tiempo que hemos trabajado juntos en los proyectos.",
    comment2:
      "Demuestra constantemente una voluntad de ayudar a los demás, ya sea brindando soporte técnico, compartiendo sus conocimientos o asumiendo tareas adicionales cuando sea necesario.",
    comment3:
      "Sebastián cumple constantemente los plazos y alcanza los objetivos establecidos, demostrando su profesionalismo y dedicación a su trabajo.",
    role: "Project Manager",
    profilePicture: milagrosImage,
  },
  {
    name: "Ayrton Juarez",
    comment:
      "Tuve la oportunidad de seguir el crecimiento profesional de Sebastián como desarrollador de software.",
    comment2:
      "Es un excelente profesional, con un amplio dominio de las últimas tecnologías y una gran disposición para colaborar y seguir aprendiendo y perfeccionando sus habilidades.",
    comment3:
      "Sin duda un placer trabajar con él y definitivamente volvería a hacerlo por el valor que aporta al equipo de desarrollo.",
    role: "Desarrollador de Software",
    profilePicture: ayrtonImage,
  },
  {
    name: "Tomas Goyret",
    comment:
      "Sebas es increíble! Trabajamos juntos desarrollando una app para una fundación con un gran impacto.",
    comment2:
      "Su incorporación al equipo de desarrollo fue clave para impulsar el desarrollo. Debo destacar su compromiso, su disposición a resolver problemas en cualquier momento y su calidad técnica.",
    comment3: "Fue un verdadero placer trabajar con él.",
    role: "Desarrollador de Software",
    profilePicture: tomasImage,
  },
  {
    name: "Francisco Schlatter",
    comment:
      "Trabajar con Sebastián fue una experiencia increíble. Sus conocimientos técnicos y habilidades de desarrollo son de alto nivel.",
    comment2:
      "Él constantemente va más allá para ofrecer resultados geniales, superando constantemente las expectativas.",
    comment3:
      "Su capacidad para resolver eficientemente problemas complejos, sumada a su actitud positiva, lo convierten en un colaborador altamente confiable.",
    role: "Desarrollador Full Stack",
    profilePicture: franImage,
  },
  {
    name: "Lucas Pedreira",
    comment:
      "Tuve la oportunidad de trabajar estrechamente con Sebastián y puedo decir que fue una experiencia muy positiva.",
    comment2:
      "Demostró constantemente su disposición a ayudar a los demás, brindar valiosos consejos y estar abierto a recibir retroalimentación. Su pasión por su trabajo es evidente y se dedica con entusiasmo a cada tarea.",
    comment3: "Es un activo valioso para cualquier equipo o proyecto.",
    role: "Desarrollador Freelance",
    profilePicture: lucasImage,
  },
];
